const STORAGE_KEY = "fx.ui.language";
export const APP_LANGUAGE_EVENT = "fx-app-language";

/** MT5-style language list: English first, then A–Z by English name. */
export const APP_LANGUAGES = [
  { id: "en", code: "EN", label: "English", native: "English" },
  { id: "ar", code: "AR", label: "Arabic", native: "العربية" },
  { id: "bg", code: "BG", label: "Bulgarian", native: "Български език" },
  { id: "zh-Hans", code: "ZH", label: "Chinese Simplified", native: "简体中文" },
  { id: "zh-Hant", code: "ZH", label: "Chinese Traditional", native: "中國傳統的" },
  { id: "cs", code: "CS", label: "Czech", native: "Čeština" },
  { id: "nl", code: "NL", label: "Dutch", native: "Nederlands" },
  { id: "fr", code: "FR", label: "French", native: "Français" },
  { id: "de", code: "DE", label: "German", native: "Deutsch" },
  { id: "el", code: "EL", label: "Greek", native: "Ελληνικά" },
  { id: "he", code: "HE", label: "Hebrew", native: "עברית" },
  { id: "hi", code: "HI", label: "Hindi", native: "हिन्दी" },
  { id: "hu", code: "HU", label: "Hungarian", native: "Magyar" },
  { id: "id", code: "ID", label: "Indonesian", native: "Bahasa Indonesia" },
  { id: "it", code: "IT", label: "Italian", native: "Italiano" },
  { id: "ja", code: "JA", label: "Japanese", native: "日本語" },
  { id: "ko", code: "KO", label: "Korean", native: "한국어" },
  { id: "ms", code: "MS", label: "Malay", native: "Bahasa Melayu" },
  { id: "fa", code: "FA", label: "Persian", native: "فارسی" },
  { id: "pl", code: "PL", label: "Polish", native: "Polski" },
  { id: "pt", code: "PT", label: "Portuguese", native: "Português" },
  { id: "ro", code: "RO", label: "Romanian", native: "Română" },
  { id: "ru", code: "RU", label: "Russian", native: "Русский" },
  { id: "es", code: "ES", label: "Spanish", native: "Español" },
  { id: "th", code: "TH", label: "Thai", native: "ภาษาไทย" },
  { id: "tr", code: "TR", label: "Turkish", native: "Türkçe" },
  { id: "uk", code: "UK", label: "Ukrainian", native: "Українська" },
  { id: "uz", code: "UZ", label: "Uzbek", native: "Oʻzbek" },
  { id: "vi", code: "VI", label: "Vietnamese", native: "Tiếng Việt Nam" },
];

/** Settings Language tab: English and Hindi only. */
export const SELECTABLE_APP_LANGUAGES = APP_LANGUAGES.filter(
  (lang) => lang.id === "en" || lang.id === "hi"
);

const STRINGS = {
  en: {
    settings: "Settings",
    language: "Language",
    aboutProgram: "About Program",
    wallet: "Wallet",
    darkTheme: "Dark Theme",
    lightTheme: "Light Theme",
    colorTemplates: "Color Templates",
    history: "History",
    banned: "Banned/Blocked Scripts",
    maxqty: "Max Quantity Details",
    reports: "Reports",
    tradeReport: "Trade Report",
    ledgerReport: "Ledger Report",
    orderRejectionLog: "Order/Trade Rejection Log",
    orderEditDeleteLog: "Order/Trade Edit/Delete Log",
    trialBalance: "Trial Balance",
    logout: "Logout",
    search: "Search",
    tradingAccounts: "Trading Accounts",
    shortcuts: "Shortcuts",
  },
  hi: {
    settings: "सेटिंग",
    language: "भाषा",
    aboutProgram: "प्रोग्राम के बारे में",
    wallet: "वॉलेट",
    darkTheme: "डार्क थीम",
    lightTheme: "लाइट थीम",
    colorTemplates: "कलर टेम्पलेट",
    history: "इतिहास",
    banned: "बैन/ब्लॉक स्क्रिप्ट",
    maxqty: "मैक्स क्वांटिटी",
    reports: "रिपोर्ट्स",
    tradeReport: "ट्रेड रिपोर्ट",
    ledgerReport: "लेजर रिपोर्ट",
    orderRejectionLog: "ऑर्डर/ट्रेड रिजेक्शन लॉग",
    orderEditDeleteLog: "ऑर्डर/ट्रेड एडिट/डिलीट लॉग",
    trialBalance: "ट्रायल बैलेंस",
    logout: "लॉग आउट",
    search: "खोजें",
    tradingAccounts: "ट्रेडिंग खाते",
    shortcuts: "शॉर्टकट",
  },
  ar: {
    settings: "الإعدادات",
    language: "اللغة",
    aboutProgram: "حول البرنامج",
    wallet: "المحفظة",
    darkTheme: "الوضع الداكن",
    lightTheme: "الوضع الفاتح",
    colorTemplates: "قوالب الألوان",
    history: "السجل",
    banned: "الرموز المحظورة",
    maxqty: "الحد الأقصى للكمية",
    reports: "التقارير",
    logout: "تسجيل الخروج",
    search: "بحث",
    tradingAccounts: "حسابات التداول",
    shortcuts: "اختصارات",
  },
  fr: {
    settings: "Paramètres",
    language: "Langue",
    aboutProgram: "À propos du programme",
    wallet: "Portefeuille",
    darkTheme: "Thème sombre",
    lightTheme: "Thème clair",
    colorTemplates: "Modèles de couleurs",
    history: "Historique",
    banned: "Scripts bloqués",
    maxqty: "Quantité maximale",
    reports: "Rapports",
    logout: "Déconnexion",
    search: "Rechercher",
    tradingAccounts: "Comptes de trading",
    shortcuts: "Raccourcis",
  },
  de: {
    settings: "Einstellungen",
    language: "Sprache",
    aboutProgram: "Über das Programm",
    wallet: "Wallet",
    darkTheme: "Dunkles Design",
    lightTheme: "Helles Design",
    colorTemplates: "Farbvorlagen",
    history: "Verlauf",
    banned: "Gesperrte Skripte",
    maxqty: "Maximale Menge",
    reports: "Berichte",
    logout: "Abmelden",
    search: "Suchen",
    tradingAccounts: "Handelskonten",
    shortcuts: "Tastenkürzel",
  },
  es: {
    settings: "Ajustes",
    language: "Idioma",
    aboutProgram: "Acerca del programa",
    wallet: "Cartera",
    darkTheme: "Tema oscuro",
    lightTheme: "Tema claro",
    colorTemplates: "Plantillas de color",
    history: "Historial",
    banned: "Scripts bloqueados",
    maxqty: "Cantidad máxima",
    reports: "Informes",
    logout: "Cerrar sesión",
    search: "Buscar",
    tradingAccounts: "Cuentas de trading",
    shortcuts: "Atajos",
  },
  pt: {
    settings: "Definições",
    language: "Idioma",
    aboutProgram: "Sobre o programa",
    wallet: "Carteira",
    darkTheme: "Tema escuro",
    lightTheme: "Tema claro",
    colorTemplates: "Modelos de cor",
    history: "Histórico",
    banned: "Scripts bloqueados",
    maxqty: "Quantidade máxima",
    reports: "Relatórios",
    logout: "Sair",
    search: "Pesquisar",
    tradingAccounts: "Contas de trading",
    shortcuts: "Atalhos",
  },
  ru: {
    settings: "Настройки",
    language: "Язык",
    aboutProgram: "О программе",
    wallet: "Кошелёк",
    darkTheme: "Тёмная тема",
    lightTheme: "Светлая тема",
    colorTemplates: "Цветовые шаблоны",
    history: "История",
    banned: "Заблокированные скрипты",
    maxqty: "Макс. объём",
    reports: "Отчёты",
    logout: "Выход",
    search: "Поиск",
    tradingAccounts: "Торговые счета",
    shortcuts: "Горячие клавиши",
  },
  "zh-Hans": {
    settings: "设置",
    language: "语言",
    aboutProgram: "关于程序",
    wallet: "钱包",
    darkTheme: "深色主题",
    lightTheme: "浅色主题",
    colorTemplates: "颜色模板",
    history: "历史",
    banned: "禁/封脚本",
    maxqty: "最大数量",
    reports: "报表",
    logout: "退出",
    search: "搜索",
    tradingAccounts: "交易账户",
    shortcuts: "快捷键",
  },
  "zh-Hant": {
    settings: "設定",
    language: "語言",
    aboutProgram: "關於程式",
    wallet: "錢包",
    darkTheme: "深色主題",
    lightTheme: "淺色主題",
    colorTemplates: "顏色範本",
    history: "歷史",
    banned: "禁/封腳本",
    maxqty: "最大數量",
    reports: "報表",
    logout: "登出",
    search: "搜尋",
    tradingAccounts: "交易帳戶",
    shortcuts: "快捷鍵",
  },
  ja: {
    settings: "設定",
    language: "言語",
    aboutProgram: "プログラムについて",
    wallet: "ウォレット",
    darkTheme: "ダークテーマ",
    lightTheme: "ライトテーマ",
    colorTemplates: "カラーテンプレート",
    history: "履歴",
    banned: "禁止スクリプト",
    maxqty: "最大数量",
    reports: "レポート",
    logout: "ログアウト",
    search: "検索",
    tradingAccounts: "取引口座",
    shortcuts: "ショートカット",
  },
  ko: {
    settings: "설정",
    language: "언어",
    aboutProgram: "프로그램 정보",
    wallet: "지갑",
    darkTheme: "다크 테마",
    lightTheme: "라이트 테마",
    colorTemplates: "색상 템플릿",
    history: "기록",
    banned: "차단된 종목",
    maxqty: "최대 수량",
    reports: "리포트",
    logout: "로그아웃",
    search: "검색",
    tradingAccounts: "거래 계좌",
    shortcuts: "단축키",
  },
  tr: {
    settings: "Ayarlar",
    language: "Dil",
    aboutProgram: "Program hakkında",
    wallet: "Cüzdan",
    darkTheme: "Koyu tema",
    lightTheme: "Açık tema",
    colorTemplates: "Renk şablonları",
    history: "Geçmiş",
    banned: "Engellenen scriptler",
    maxqty: "Maksimum miktar",
    reports: "Raporlar",
    logout: "Çıkış",
    search: "Ara",
    tradingAccounts: "İşlem hesapları",
    shortcuts: "Kısayollar",
  },
  it: {
    settings: "Impostazioni",
    language: "Lingua",
    aboutProgram: "Informazioni sul programma",
    wallet: "Portafoglio",
    darkTheme: "Tema scuro",
    lightTheme: "Tema chiaro",
    colorTemplates: "Modelli colore",
    history: "Cronologia",
    banned: "Script bloccati",
    maxqty: "Quantità massima",
    reports: "Report",
    logout: "Esci",
    search: "Cerca",
    tradingAccounts: "Conti di trading",
    shortcuts: "Scorciatoie",
  },
  id: {
    settings: "Pengaturan",
    language: "Bahasa",
    aboutProgram: "Tentang program",
    wallet: "Dompet",
    darkTheme: "Tema gelap",
    lightTheme: "Tema terang",
    colorTemplates: "Templat warna",
    history: "Riwayat",
    banned: "Skrip diblokir",
    maxqty: "Kuantitas maksimum",
    reports: "Laporan",
    logout: "Keluar",
    search: "Cari",
    tradingAccounts: "Akun trading",
    shortcuts: "Pintasan",
  },
  th: {
    settings: "การตั้งค่า",
    language: "ภาษา",
    aboutProgram: "เกี่ยวกับโปรแกรม",
    wallet: "กระเป๋าเงิน",
    darkTheme: "ธีมมืด",
    lightTheme: "ธีมสว่าง",
    colorTemplates: "เทมเพลตสี",
    history: "ประวัติ",
    banned: "สคริปต์ที่ถูกบล็อก",
    maxqty: "ปริมาณสูงสุด",
    reports: "รายงาน",
    logout: "ออกจากระบบ",
    search: "ค้นหา",
    tradingAccounts: "บัญชีเทรด",
    shortcuts: "ทางลัด",
  },
  vi: {
    settings: "Cài đặt",
    language: "Ngôn ngữ",
    aboutProgram: "Giới thiệu chương trình",
    wallet: "Ví",
    darkTheme: "Giao diện tối",
    lightTheme: "Giao diện sáng",
    colorTemplates: "Mẫu màu",
    history: "Lịch sử",
    banned: "Mã bị chặn",
    maxqty: "Khối lượng tối đa",
    reports: "Báo cáo",
    logout: "Đăng xuất",
    search: "Tìm kiếm",
    tradingAccounts: "Tài khoản giao dịch",
    shortcuts: "Phím tắt",
  },
  uk: {
    settings: "Налаштування",
    language: "Мова",
    aboutProgram: "Про програму",
    wallet: "Гаманець",
    darkTheme: "Темна тема",
    lightTheme: "Світла тема",
    colorTemplates: "Кольорові шаблони",
    history: "Історія",
    banned: "Заблоковані скрипти",
    maxqty: "Макс. обсяг",
    reports: "Звіти",
    logout: "Вийти",
    search: "Пошук",
    tradingAccounts: "Торгові рахунки",
    shortcuts: "Ярлики",
  },
  pl: {
    settings: "Ustawienia",
    language: "Język",
    aboutProgram: "O programie",
    wallet: "Portfel",
    darkTheme: "Ciemny motyw",
    lightTheme: "Jasny motyw",
    colorTemplates: "Szablony kolorów",
    history: "Historia",
    banned: "Zablokowane skrypty",
    maxqty: "Maks. ilość",
    reports: "Raporty",
    logout: "Wyloguj",
    search: "Szukaj",
    tradingAccounts: "Konta tradingowe",
    shortcuts: "Skróty",
  },
};

function isBrowser() {
  return typeof window !== "undefined";
}

export function getAppLanguageById(id) {
  return APP_LANGUAGES.find((lang) => lang.id === id) || APP_LANGUAGES[0];
}

export function loadAppLanguageId() {
  if (!isBrowser()) return "en";
  try {
    const stored = String(window.localStorage.getItem(STORAGE_KEY) || "").trim();
    if (SELECTABLE_APP_LANGUAGES.some((lang) => lang.id === stored)) return stored;
  } catch {
    /* ignore */
  }
  return "en";
}

export function loadAppLanguage() {
  return getAppLanguageById(loadAppLanguageId());
}

export function applyAppLanguage(id) {
  const lang = getAppLanguageById(id || loadAppLanguageId());
  if (!isBrowser()) return lang;
  const html = document.documentElement;
  html.lang = lang.id;
  html.dir = lang.id === "ar" || lang.id === "he" || lang.id === "fa" ? "rtl" : "ltr";
  html.setAttribute("data-ui-lang", lang.id);
  return lang;
}

export function saveAppLanguage(id) {
  const lang = getAppLanguageById(id);
  if (isBrowser()) {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang.id);
    } catch {
      /* ignore */
    }
    applyAppLanguage(lang.id);
    window.dispatchEvent(new CustomEvent(APP_LANGUAGE_EVENT, { detail: { id: lang.id } }));
  }
  return lang;
}

/** App chrome (footer, quotes, menus, trade/history). Missing keys fall back to English. */
const CHROME_EN = {
  quotes: "Quotes",
  chart: "Chart",
  trade: "Trade",
  searchSymbol: "Search symbol",
  addSymbol: "Add symbol",
  symbol: "Symbol",
  bid: "Bid",
  ask: "Ask",
  ltp: "LTP",
  dailyChange: "Daily Change",
  time: "Time",
  comment: "Comment",
  depthOfMarket: "Depth of Market",
  lot: "Lot",
  instrument: "Instrument",
  market: "Market",
  expiry: "Expiry",
  change: "Change",
  open: "Open",
  high: "High",
  low: "Low",
  prevClose: "Prev. close",
  sessions: "Sessions",
  swapRates: "Swap rates",
  weekdaySun: "Sunday",
  weekdayMon: "Monday",
  weekdayTue: "Tuesday",
  weekdayWed: "Wednesday",
  weekdayThu: "Thursday",
  weekdayFri: "Friday",
  weekdaySat: "Saturday",
  noSymbols: "No symbols. Click search bar to add.",
  placingOrder: "Placing order…",
  placeOrder: "Place Order",
  newOrder: "New Order",
  specification: "Specification",
  hide: "Hide",
  removeFromWatchlist: "Remove from watchlist",
  chartSettings: "Chart Settings",
  positions: "Positions",
  deals: "Deals",
  orders: "Orders",
  order: "Order",
  closedPositions: "Closed Positions",
  closePosition: "Close Position",
  modifyPosition: "Modify Position",
  noOpenPositions: "No open positions.",
  buy: "Buy",
  sell: "Sell",
  buyNow: "Buy Now",
  sellNow: "Sell Now",
  sellByMarket: "Sell by Market",
  buyByMarket: "Buy by Market",
  marketExecution: "Market Execution",
  buyLimit: "Buy Limit",
  sellLimit: "Sell Limit",
  buyStop: "Buy Stop",
  sellStop: "Sell Stop",
  backToChart: "← Chart",
  backToQuotes: "Back to Quotes",
  period: "Period",
  sortBy: "Sort By",
  today: "Today",
  lastWeek: "Last week",
  lastMonth: "Last Month",
  last3Months: "Last 3 Months",
  last6Months: "Last 6 Months",
  lastYear: "Last year",
  allHistory: "All History",
  customPeriod: "Custom Period",
  byDefault: "By Default",
  openTimeSort: "Open Time",
  closeTime: "Close Time",
  ticket: "Ticket",
  close: "Close",
  keyboardShortcuts: "Keyboard Shortcuts",
  shortcutGlobal: "Global",
  shortcutTrading: "Trading",
  shortcutOpenHelp: "Open shortcuts help",
  shortcutOpenWatchlist: "Open watchlist panel / return to chart page",
  shortcutCollapsePosition: "Collapse / expand position panel",
  shortcutCloseDialog: "Close open dialog / panel",
  shortcutOpenQuickOrder: "Open / close quick order for selected symbol",
  shortcutZoomIn: "Zoom in chart",
  shortcutZoomOut: "Zoom out chart",
  shortcutScrollChart: "Scroll chart left / right",
  shortcutMouseWheel: "Scroll chart (Ctrl + wheel to zoom)",
  shortcutSaveChart: "Save chart as image (PNG)",
  gotIt: "Got it",
  cancel: "Cancel",
  selectIndicator: "Select indicator",
  addIndicator: "Add indicator",
  indTabAll: "All",
  indTabTrend: "Trend",
  indTabOscillators: "Oscillators",
  indTabVolumes: "Volumes",
  indTabBillWilliams: "Bill Williams",
  showAllTimeframes: "Show on all the timeframes",
  confirm: "Confirm",
  done: "Done",
  menu: "Menu",
  volume: "Volume",
  price: "Price",
  stopLoss: "Stop Loss",
  takeProfit: "Take Profit",
  viewOnly: "View only",
  clearWatchlist: "Clear watchlist?",
  removeAll: "Remove all",
  pending: "Pending",
  profit: "Profit",
  credit: "Credit",
  balance: "Balance",
  margin: "Margin",
  equity: "Equity",
  holding: "Holding",
  level: "Level",
  freeMargin: "Free margin",
  deposit: "Deposit",
  withdrawal: "Withdrawal",
  commission: "Commission",
  charges: "Charges",
  grossProfit: "Gross Profit",
  pnl: "P&L",
  used: "Used",
  free: "Free",
  withdrawable: "Withdrawable",
  marginLevel: "Margin Level (%)",
  loading: "Loading…",
  total: "Total",
  filled: "Filled",
  canceled: "Canceled",
  rejected: "Rejected",
  fee: "Fee",
  swap: "Swap",
  refresh: "Refresh",
  accountSummary: "Account summary",
  positionTicket: "Position",
  qty: "Qty",
  lots: "Lots",
  type: "Type",
  entry: "Entry",
  setup: "Setup",
  state: "State",
  openPriceLabel: "Open Price",
  closePriceLabel: "Close Price",
  positionHash: "Position#",
  orderHash: "Order#",
  account: "Account",
  walletSubtitle: "Balance, credit, equity, margin, deposits & withdrawals",
  overview: "Overview",
  addFunds: "Add funds",
  withdraw: "Withdraw",
  statement: "Statement",
  depositToLedger: "Deposit to ledger",
  requestPayout: "Request payout",
  viewHistory: "View history",
  chooseQuickAction: "Choose a quick action or switch tabs for the full flow.",
  availableBalance: "Available balance",
  signInWithdraw: "Sign in to request withdrawals.",
  signInStatement: "Sign in to view your statement.",
  addPoint: "Add point",
  addPointUnavailable: "Add point is not available for this account.",
  chooseHowAddFunds: "Choose how you want to add funds",
  updatingOptions: "Updating options…",
  noPaymentOptions: "No payment options are configured. Contact support.",
  payOnline: "Pay online",
  requestAddPointChat: "Request add point via chat",
  continue: "Continue",
  enterAmount: "Enter amount",
  amountMin500: "Amount (min. 500)",
  minAmount500: "Minimum amount is 500.",
  back: "Back",
  submitAndPay: "Submit & pay",
  makePayment: "Make payment",
  submitting: "Submitting…",
  bankTransfer: "Bank transfer",
  copy: "Copy",
  copied: "Copied",
  copiedToClipboard: "Copied to clipboard",
  tapToEnlarge: "Tap to enlarge",
  allowed: "Allowed:",
  paymentProof: "Payment proof",
  transactionId: "Transaction ID",
  enterTransactionId: "Enter transaction ID",
  amount: "Amount",
  remarkOptional: "Remark (optional)",
  remark: "Remark",
  paymentScreenshot: "Payment screenshot",
  submitRequest: "Submit request",
  txnIdRequired: "Transaction ID is required",
  amountRequired: "Amount is required",
  amountPositive: "Amount must be positive",
  amountMustBeBetween: "Amount must be between {min} and {max}",
  paymentReceiptRequired: "Payment receipt is required",
  requestWithdraw: "Request withdraw",
  myBanks: "My banks",
  withdrawHint: "Enter amount and payout details. Select a saved bank to autofill. Use Withdrawable from the summary above as your max.",
  withdrawAmount: "Withdraw amount",
  payoutAccount: "Payout account",
  savedBank: "Saved bank",
  selectSavedBank: "Select saved bank or enter manually",
  enterManually: "Enter manually",
  beneficiaryName: "Beneficiary name",
  accountHolderName: "Account holder name",
  bankName: "Bank name",
  accountNumber: "Account number",
  submitWithdrawRequest: "Submit withdraw request",
  noSavedBanks: "No saved banks yet. Add one to speed up withdrawals.",
  addBankAccount: "+ Add bank account",
  editBank: "Edit bank",
  addBank: "Add bank",
  savePayoutDetails: "Save payout details for faster withdrawals",
  saving: "Saving…",
  saveBank: "Save bank",
  removeThisBank: "Remove this bank?",
  removeBankText: "It will be removed from your saved list. You can add it again later.",
  yesRemove: "Yes, remove",
  edit: "Edit",
  remove: "Remove",
  validUpi: "Enter a valid UPI ID",
  upiRequired: "UPI ID is required",
  beneficiaryRequired: "Beneficiary name is required",
  bankNameRequired: "Bank name is required",
  validIfsc: "Enter a valid IFSC code",
  ifscRequired: "IFSC code is required",
  accountNumberRequired: "Account number is required",
  amountMustBeNumber: "Amount must be a number",
  amountExceedsWithdrawable: "Amount cannot exceed withdrawable ₹{amount}",
  amountExceedsLimit: "Amount exceeds withdrawable limit",
  viewStatement: "View statement",
  withdrawFunds: "Withdraw funds",
  noAddFundRecords: "No add-fund records.",
  noWithdrawRecords: "No withdraw records.",
  transactions: "Transactions",
  loadingMore: "Loading more…",
  status: "Status",
  date: "Date",
  debit: "Debit",
  bank: "Bank",
  beneficiary: "Beneficiary",
  amountInr: "Amount (₹)",
  openUpiQr: "Open UPI QR",
  closeQr: "Close QR",
  upiQrCode: "UPI QR code",
  qrImageMissing: "QR image not found. Use the UPI ID or bank details instead.",
  approved: "Approved",
  success: "Success",
  failed: "Failed",
  openTime: "Open",
  segment: "Segment",
  closeAllPositions: "Close All Positions",
  modify: "Modify",
  slShort: "S / L",
  tpShort: "T / P",
  login: "Login",
  loginRegister: "Login / Register",
  accounts: "Accounts",
  connectToAccount: "Connect to account",
  instantDemo: "Instant Demo",
  enterLogin: "Enter login",
  enterPassword: "Enter password",
  pleaseWait: "Please wait…",
  password: "Password",
  server: "Server",
  savePassword: "Save password",
  signOut: "Sign out",
  changePassword: "Change password",
  noAccountsYet: "No accounts yet.",
  connectFromLoginTab: "Connect one from Login tab.",
  selectAnAccount: "Select an account from the list.",
  tradingAccountsHeading: "Trading accounts: FxBazzar Ltd.",
  ok: "Ok",
  statusLine: "Status line",
  scalesAndLines: "Scales and lines",
  canvas: "Canvas",
  realAccountLoginOnly: "Real account login only. Use the login screen Instant Demo for a demo user.",
  pleaseEnterLoginPassword: "Please enter login and password",
  name: "Name",
  userCode: "User Code",
  saved: "Saved",
  currentPassword: "Current Password",
  newPassword: "New Password",
  confirmPassword: "Confirm Password",
  enterCurrentPassword: "Enter current password",
  enterNewPassword: "Enter new password",
  passwordChangeHint: "After a successful change, sign in with your new password. The old password will no longer work.",
  passwordUpdated: "Password updated on the server. Use your new password next time you sign in.",
  updating: "Updating…",
  instantDemoNoPassword: "Instant Demo has no password to change.",
  reconnectToChangePassword: "Reconnect from Login to change password.",
  eula: "End-User License Agreement",
  noAccountsGoLogin: "No accounts yet. Go to Login tab to connect.",
  connectedPrefix: "Connected —",
  switchedToPrefix: "Switched to",
  signingOut: "Signing out…",
  removedAccountPrefix: "Removed account",
  enterCurrentPasswordErr: "Enter current password.",
  passwordMismatch: "Passwords don't match.",
  sessionTokenMissing: "Session token missing. Connect again from the Login tab.",
  newPasswordRule: "New password must be at least 8 characters and include uppercase, lowercase, a number, and a special character (!@#$%^&*).",
  colorTplGreenRed: "Green & Red",
  colorTplBlueRed: "Blue & Red",
  colorTplBlackWhite: "Black & White",
  colorTplNeutral: "Neutral",
  selected: "Selected",
  bannedScriptTab: "Banned Script",
  blockedScriptTab: "Blocked Script",
  noBannedScripts: "No banned scripts found",
  noBlockedScripts: "No blocked scripts found",
  script: "Script",
  fromDate: "From Date",
  toDate: "To Date",
  blockBy: "Block By",
  noDataFound: "No data found",
  record: "record",
  records: "records",
  client: "Client",
  searchScriptMarket: "Search script / market…",
  getMaxQtyDetails: "Get Max Quantity Details",
  dataNotFound: "Data Not Found",
  noDataToExport: "No data found to export.",
  selectSegmentFirst: "Please select a segment first.",
  selectSegmentExcel: "Please select a segment before exporting Excel.",
  generating: "Generating...",
  pdf: "PDF",
  excel: "Excel",
  totalRecords: "Total Records",
  authority: "Authority",
  rateStart: "Rate Start",
  rateEnd: "Rate End",
  positionLimit: "Position Limit",
  maxOrder: "Max Order",
  minOrder: "Min Order",
  mobileTradingTerminal: "Mobile Trading Terminal",
  version: "Version",
  aboutTagline:
    "FxBazzar is a professional trading workspace for Indian derivatives and commodities — built for traders who need live markets, fast order entry, wallet management, and full account reporting on mobile.",
  whatYouCanDo: "What you can do",
  aboutMw: "Market Watch",
  aboutMwDesc: "Live bid, ask & LTP with personal watchlists across segments",
  aboutCharts: "Charts",
  aboutChartsDesc: "Candles, line, bars & area — multi-timeframe OHLC with volume",
  aboutTradeOrders: "Trade & Orders",
  aboutTradeOrdersDesc: "Quick order entry, trade book, order book & live positions",
  aboutWalletDesc: "Add funds, withdraw, bank payout & account statement",
  aboutReportsDesc: "Ledger, trade report, trial balance & audit logs",
  aboutAccounts: "Accounts",
  aboutAccountsDesc: "Switch trading accounts; view-password read-only mode",
  marketsAndSegments: "Markets & segments",
  nseFutures: "NSE Futures",
  nseOptions: "NSE Options",
  mcxCommodities: "MCX Commodities",
  indexNifty: "Index (NIFTY / BANKNIFTY / SENSEX)",
  giftNifty: "GIFT NIFTY",
  aboutPlatform: "Platform",
  aboutNote1: "Synced with the FxBazzar web terminal — same login, positions, and wallet.",
  aboutNote2: "Realtime quotes via Socket.IO; orders, reports, and ledger via secure REST API.",
  aboutNote3: "Chart preferences, color templates, and dark/light theme saved on your device.",
  technology: "Technology",
  aboutDisclaimer:
    "Trading in futures, options, and commodities involves substantial risk of loss. Only trade with capital you can afford to lose and within your broker's risk limits.",
  website: "Website",
  aboutLiveData: "Live market data via Socket.IO · Account data via FastTrade API",
  allRightsReserved: "All rights reserved.",
  scriptNotFound: "Script not found",
  sessionExpired: "Session expired. Please log in again.",
  positionNotFoundOrClosed: "Position not found or already closed.",
};

const CHROME = {
  hi: {
    quotes: "भाव",
    chart: "चार्ट",
    trade: "ट्रेड",
    searchSymbol: "खोज प्रतीक",
    addSymbol: "प्रतीक जोड़ें",
    symbol: "प्रतीक",
    bid: "बोली",
    ask: "मांग",
    ltp: "एलटीपी",
    dailyChange: "दैनिक बदलाव",
    time: "समय",
    comment: "टिप्पणी",
    depthOfMarket: "डेप्थ ऑफ़ मार्किट(बाजार की गहराई)",
    lot: "लॉट",
    instrument: "इंस्ट्रूमेंट",
    market: "बाज़ार",
    expiry: "समाप्ति",
    change: "बदलाव",
    open: "खुला",
    high: "उच्च",
    low: "निम्न",
    prevClose: "पिछला बंद",
    sessions: "सत्र",
    swapRates: "स्वैप दरें",
    weekdaySun: "रविवार",
    weekdayMon: "सोमवार",
    weekdayTue: "मंगलवार",
    weekdayWed: "बुधवार",
    weekdayThu: "बृहस्पतिवार",
    weekdayFri: "शुक्रवार",
    weekdaySat: "शनिवार",
    noSymbols: "कोई प्रतीक नहीं। जोड़ने के लिए खोज बार टैप करें।",
    placingOrder: "आदेश लगाया जा रहा है…",
    placeOrder: "आदेश लगाएँ",
    newOrder: "नया आदेश",
    specification: "विशेष विवरण",
    hide: "छिपायें",
    removeFromWatchlist: "वॉचलिस्ट से हटाएँ",
    chartSettings: "चार्ट सेटिंग",
    positions: "पोज़ीशन",
    deals: "सौदे",
    orders: "आदेश",
    order: "आदेश",
    closedPositions: "बंद पोज़ीशन",
    closePosition: "पोज़ीशन बंद करें",
    modifyPosition: "पोज़ीशन संशोधित करें",
    noOpenPositions: "कोई खुली पोज़ीशन नहीं।",
    buy: "खरीदें",
    sell: "बेचें",
    buyNow: "अभी खरीदें",
    sellNow: "अभी बेचें",
    sellByMarket: "Sell by Market",
    buyByMarket: "Buy by Market",
    marketExecution: "बाजार निष्पादन",
    buyLimit: "बाई लिमिट",
    sellLimit: "सेल लिमिट",
    buyStop: "बाई स्टॉप",
    sellStop: "सेल स्टॉप",
    backToChart: "← चार्ट",
    backToQuotes: "भाव पर वापस",
    period: "अवधि",
    sortBy: "क्रमबद्ध करें",
    today: "आज",
    lastWeek: "पिछले सप्ताह",
    lastMonth: "पिछले महीने",
    last3Months: "पिछले 3 महीने",
    last6Months: "पिछले 6 महीने",
    lastYear: "पिछले वर्ष",
    allHistory: "पूरा इतिहास",
    customPeriod: "कस्टम अवधि",
    byDefault: "डिफ़ॉल्ट रूप से",
    openTimeSort: "खुलने का समय",
    closeTime: "बंद होने का समय",
    ticket: "टिकट",
    close: "बंद करें",
    keyboardShortcuts: "कीबोर्ड शॉर्टकट",
    shortcutGlobal: "ग्लोबल",
    shortcutTrading: "ट्रेडिंग",
    shortcutOpenHelp: "शॉर्टकट सहायता खोलें",
    shortcutOpenWatchlist: "वॉचलिस्ट पैनल खोलें / चार्ट पेज पर लौटें",
    shortcutCollapsePosition: "पोज़ीशन पैनल संक्षिप्त / विस्तृत करें",
    shortcutCloseDialog: "खुला डायलॉग / पैनल बंद करें",
    shortcutOpenQuickOrder: "चयनित प्रतीक के लिए क्विक ऑर्डर खोलें / बंद करें",
    shortcutZoomIn: "चार्ट ज़ूम इन",
    shortcutZoomOut: "चार्ट ज़ूम आउट",
    shortcutScrollChart: "चार्ट बाएँ / दाएँ स्क्रॉल करें",
    shortcutMouseWheel: "चार्ट स्क्रॉल (ज़ूम के लिए Ctrl + व्हील)",
    shortcutSaveChart: "चार्ट PNG के रूप में सेव करें",
    gotIt: "समझ गया",
    cancel: "रद्द करें",
    selectIndicator: "संकेतक चुनें",
    addIndicator: "संकेतक जोड़ें",
    indTabAll: "सभी",
    indTabTrend: "ट्रेंड",
    indTabOscillators: "ऑसिलेटर",
    indTabVolumes: "वॉल्यूम",
    indTabBillWilliams: "बिल विलियम्स",
    showAllTimeframes: "सभी टाइमफ्रेम पर दिखाएँ",
    confirm: "पुष्टि करें",
    done: "हो गया",
    menu: "मेनू",
    volume: "वॉल्यूम",
    price: "कीमत",
    stopLoss: "स्टॉप लॉस",
    takeProfit: "प्रॉफिट लें",
    modify: "संशोधित करें",
    slShort: "S / L",
    tpShort: "T / P",
    viewOnly: "केवल देखने के लिए",
    clearWatchlist: "वॉचलिस्ट साफ़ करें?",
    removeAll: "सभी हटाएँ",
    pending: "लंबित",
    profit: "लाभ",
    credit: "क्रेडिट",
    balance: "बैलेंस",
    margin: "मार्जिन",
    equity: "इक्विटी",
    holding: "होल्डिंग",
    level: "स्तर",
    freeMargin: "फ्री मार्जिन",
    deposit: "डिपॉजिट",
    withdrawal: "निकासी",
    commission: "कमीशन",
    charges: "चार्जेस",
    grossProfit: "सकल लाभ",
    fee: "शुल्क",
    swap: "स्वैप",
    pnl: "लाभ-हानि",
    used: "उपयोग",
    free: "फ्री",
    withdrawable: "निकासी योग्य",
    marginLevel: "मार्जिन स्तर (%)",
    loading: "लोड हो रहा है…",
    total: "कुल",
    filled: "भर दिया गया",
    canceled: "रद्द हो गया",
    rejected: "अस्वीकृत",
    refresh: "रिफ़्रेश",
    accountSummary: "खाता सारांश",
    positionTicket: "पोज़ीशन",
    qty: "मात्रा",
    lots: "लॉट्स",
    type: "प्रकार",
    entry: "एंट्री",
    setup: "सेटअप",
    state: "स्थिति",
    openPriceLabel: "खुली कीमत",
    closePriceLabel: "बंद कीमत",
    positionHash: "पोज़ीशन#",
    orderHash: "आदेश#",
    account: "खाता",
    walletSubtitle: "बैलेंस, क्रेडिट, इक्विटी, मार्जिन, डिपॉजिट और निकासी",
    overview: "ओवरव्यू",
    addFunds: "फंड जोड़ें",
    withdraw: "विड्रॉ",
    statement: "स्टेटमेंट",
    depositToLedger: "लेजर में जमा करें",
    requestPayout: "पेआउट अनुरोध",
    viewHistory: "इतिहास देखें",
    chooseQuickAction: "त्वरित क्रिया चुनें या पूरा फ़्लो के लिए टैब बदलें।",
    availableBalance: "उपलब्ध बैलेंस",
    signInWithdraw: "निकासी अनुरोध के लिए साइन इन करें।",
    signInStatement: "स्टेटमेंट देखने के लिए साइन इन करें।",
    addPoint: "पॉइंट जोड़ें",
    addPointUnavailable: "इस खाते के लिए पॉइंट जोड़ना उपलब्ध नहीं है।",
    chooseHowAddFunds: "फंड जोड़ने का तरीका चुनें",
    updatingOptions: "विकल्प अपडेट हो रहे हैं…",
    noPaymentOptions: "कोई पेमेंट विकल्प सेट नहीं है। सपोर्ट से संपर्क करें।",
    payOnline: "ऑनलाइन पे करें",
    requestAddPointChat: "चैट से पॉइंट जोड़ने का अनुरोध",
    continue: "जारी रखें",
    enterAmount: "राशि दर्ज करें",
    amountMin500: "राशि (न्यूनतम 500)",
    minAmount500: "न्यूनतम राशि 500 है।",
    back: "वापस",
    submitAndPay: "सबमिट करें और पे करें",
    makePayment: "पेमेंट करें",
    submitting: "सबमिट हो रहा है…",
    bankTransfer: "बैंक ट्रांसफर",
    copy: "कॉपी",
    copied: "कॉपी हो गया",
    copiedToClipboard: "क्लिपबोर्ड पर कॉपी हो गया",
    tapToEnlarge: "बड़ा करने के लिए टैप करें",
    allowed: "अनुमत:",
    paymentProof: "पेमेंट प्रूफ",
    transactionId: "ट्रांज़ैक्शन आईडी",
    enterTransactionId: "ट्रांज़ैक्शन आईडी दर्ज करें",
    amount: "राशि",
    remarkOptional: "टिप्पणी (वैकल्पिक)",
    remark: "टिप्पणी",
    paymentScreenshot: "पेमेंट स्क्रीनशॉट",
    submitRequest: "अनुरोध सबमिट करें",
    txnIdRequired: "ट्रांज़ैक्शन आईडी ज़रूरी है",
    amountRequired: "राशि ज़रूरी है",
    amountPositive: "राशि धनात्मक होनी चाहिए",
    amountMustBeBetween: "राशि {min} और {max} के बीच होनी चाहिए",
    paymentReceiptRequired: "पेमेंट रसीद ज़रूरी है",
    requestWithdraw: "विड्रॉ अनुरोध",
    myBanks: "मेरे बैंक",
    withdrawHint: "राशि और पेआउट विवरण दर्ज करें। ऑटोफिल के लिए सेव्ड बैंक चुनें। अधिकतम के लिए ऊपर सारांश में निकासी योग्य देखें।",
    withdrawAmount: "विड्रॉ राशि",
    payoutAccount: "पेआउट खाता",
    savedBank: "सेव्ड बैंक",
    selectSavedBank: "सेव्ड बैंक चुनें या मैन्युअल दर्ज करें",
    enterManually: "मैन्युअल दर्ज करें",
    beneficiaryName: "लाभार्थी का नाम",
    accountHolderName: "खाताधारक का नाम",
    bankName: "बैंक का नाम",
    accountNumber: "खाता संख्या",
    submitWithdrawRequest: "विड्रॉ अनुरोध सबमिट करें",
    noSavedBanks: "अभी कोई सेव्ड बैंक नहीं। निकासी तेज़ करने के लिए एक जोड़ें।",
    addBankAccount: "+ बैंक खाता जोड़ें",
    editBank: "बैंक संपादित करें",
    addBank: "बैंक जोड़ें",
    savePayoutDetails: "तेज़ निकासी के लिए पेआउट विवरण सेव करें",
    saving: "सेव हो रहा है…",
    saveBank: "बैंक सेव करें",
    removeThisBank: "यह बैंक हटाएँ?",
    removeBankText: "यह आपकी सेव्ड सूची से हट जाएगा। बाद में फिर जोड़ सकते हैं।",
    yesRemove: "हाँ, हटाएँ",
    edit: "संपादित करें",
    remove: "हटाएँ",
    validUpi: "मान्य UPI ID दर्ज करें",
    upiRequired: "UPI ID ज़रूरी है",
    beneficiaryRequired: "लाभार्थी का नाम ज़रूरी है",
    bankNameRequired: "बैंक का नाम ज़रूरी है",
    validIfsc: "मान्य IFSC कोड दर्ज करें",
    ifscRequired: "IFSC कोड ज़रूरी है",
    accountNumberRequired: "खाता संख्या ज़रूरी है",
    amountMustBeNumber: "राशि एक संख्या होनी चाहिए",
    amountExceedsWithdrawable: "राशि निकासी योग्य ₹{amount} से अधिक नहीं हो सकती",
    amountExceedsLimit: "राशि निकासी योग्य सीमा से अधिक है",
    viewStatement: "स्टेटमेंट देखें",
    withdrawFunds: "फंड विड्रॉ करें",
    noAddFundRecords: "कोई फंड जोड़ने का रिकॉर्ड नहीं।",
    noWithdrawRecords: "कोई विड्रॉ रिकॉर्ड नहीं।",
    transactions: "लेनदेन",
    loadingMore: "और लोड हो रहा है…",
    status: "स्थिति",
    date: "दिनांक",
    debit: "डेबिट",
    bank: "बैंक",
    beneficiary: "लाभार्थी",
    amountInr: "राशि (₹)",
    openUpiQr: "UPI QR खोलें",
    closeQr: "QR बंद करें",
    upiQrCode: "UPI QR कोड",
    qrImageMissing: "QR इमेज नहीं मिली। UPI ID या बैंक विवरण का उपयोग करें।",
    approved: "स्वीकृत",
    success: "सफल",
    failed: "असफल",
    openTime: "खुला",
    segment: "सेगमेंट",
    closeAllPositions: "सभी पोज़ीशन बंद करें",
    login: "लॉगिन",
    loginRegister: "लॉगिन / रजिस्टर",
    accounts: "खाते",
    connectToAccount: "खाते से कनेक्ट करें",
    instantDemo: "इंस्टेंट डेमो",
    enterLogin: "लॉगिन दर्ज करें",
    enterPassword: "पासवर्ड दर्ज करें",
    pleaseWait: "कृपया प्रतीक्षा करें…",
    password: "पासवर्ड",
    server: "सर्वर",
    savePassword: "पासवर्ड सेव करें",
    signOut: "साइन आउट",
    changePassword: "पासवर्ड बदलें",
    noAccountsYet: "अभी कोई खाता नहीं।",
    connectFromLoginTab: "लॉगिन टैब से कनेक्ट करें।",
    selectAnAccount: "सूची से खाता चुनें।",
    tradingAccountsHeading: "ट्रेडिंग खाते: FxBazzar Ltd.",
    ok: "ठीक",
    statusLine: "स्टेटस लाइन",
    scalesAndLines: "स्केल और रेखाएँ",
    canvas: "कैनवास",
    realAccountLoginOnly: "केवल रियल खाता लॉगिन। डेमो यूज़र के लिए लॉगिन स्क्रीन पर इंस्टेंट डेमो इस्तेमाल करें।",
    pleaseEnterLoginPassword: "कृपया लॉगिन और पासवर्ड दर्ज करें",
    name: "नाम",
    userCode: "यूज़र कोड",
    saved: "सेव्ड",
    currentPassword: "वर्तमान पासवर्ड",
    newPassword: "नया पासवर्ड",
    confirmPassword: "पासवर्ड की पुष्टि करें",
    enterCurrentPassword: "वर्तमान पासवर्ड दर्ज करें",
    enterNewPassword: "नया पासवर्ड दर्ज करें",
    passwordChangeHint: "सफल बदलाव के बाद अपने नए पासवर्ड से साइन इन करें। पुराना पासवर्ड काम नहीं करेगा।",
    passwordUpdated: "सर्वर पर पासवर्ड अपडेट हो गया। अगली बार साइन इन करते समय नया पासवर्ड इस्तेमाल करें।",
    updating: "अपडेट हो रहा है…",
    instantDemoNoPassword: "इंस्टेंट डेमो का पासवर्ड बदलने के लिए नहीं है।",
    reconnectToChangePassword: "पासवर्ड बदलने के लिए लॉगिन से दोबारा कनेक्ट करें।",
    eula: "एंड-यूज़र लाइसेंस समझौता",
    noAccountsGoLogin: "अभी कोई खाता नहीं। कनेक्ट करने के लिए लॉगिन टैब पर जाएँ।",
    connectedPrefix: "कनेक्ट हो गया —",
    switchedToPrefix: "स्विच किया गया",
    signingOut: "साइन आउट हो रहा है…",
    removedAccountPrefix: "खाता हटाया गया",
    enterCurrentPasswordErr: "वर्तमान पासवर्ड दर्ज करें।",
    passwordMismatch: "पासवर्ड मेल नहीं खाते।",
    sessionTokenMissing: "सेशन टोकन नहीं मिला। लॉगिन टैब से दोबारा कनेक्ट करें।",
    newPasswordRule: "नया पासवर्ड कम से कम 8 अक्षर का हो और उसमें बड़ा अक्षर, छोटा अक्षर, संख्या और विशेष चिह्न (!@#$%^&*) होना चाहिए।",
    colorTplGreenRed: "हरा और लाल",
    colorTplBlueRed: "नीला और लाल",
    colorTplBlackWhite: "काला और सफेद",
    colorTplNeutral: "न्यूट्रल",
    selected: "चयनित",
    bannedScriptTab: "बैन स्क्रिप्ट",
    blockedScriptTab: "ब्लॉक स्क्रिप्ट",
    noBannedScripts: "कोई बैन स्क्रिप्ट नहीं मिली",
    noBlockedScripts: "कोई ब्लॉक स्क्रिप्ट नहीं मिली",
    script: "स्क्रिप्ट",
    fromDate: "से तिथि",
    toDate: "तक तिथि",
    blockBy: "ब्लॉक द्वारा",
    noDataFound: "कोई डेटा नहीं मिला",
    record: "रिकॉर्ड",
    records: "रिकॉर्ड",
    client: "क्लाइंट",
    searchScriptMarket: "स्क्रिप्ट / मार्केट खोजें…",
    getMaxQtyDetails: "मैक्स क्वांटिटी विवरण प्राप्त करें",
    dataNotFound: "डेटा नहीं मिला",
    noDataToExport: "एक्सपोर्ट करने के लिए डेटा नहीं मिला।",
    selectSegmentFirst: "पहले सेगमेंट चुनें।",
    selectSegmentExcel: "एक्सेल एक्सपोर्ट से पहले सेगमेंट चुनें।",
    generating: "जनरेट हो रहा है…",
    pdf: "पीडीएफ",
    excel: "एक्सेल",
    totalRecords: "कुल रिकॉर्ड",
    authority: "अथॉरिटी",
    rateStart: "रेट प्रारंभ",
    rateEnd: "रेट समाप्त",
    positionLimit: "पोज़ीशन लिमिट",
    maxOrder: "मैक्स ऑर्डर",
    minOrder: "मिन ऑर्डर",
    mobileTradingTerminal: "मोबाइल ट्रेडिंग टर्मिनल",
    version: "वर्शन",
    aboutTagline:
      "FxBazzar भारतीय डेरिवेटिव और कमोडिटी के लिए एक प्रोफेशनल ट्रेडिंग वर्कस्पेस है — उन ट्रेडर्स के लिए जो मोबाइल पर लाइव मार्केट, तेज़ ऑर्डर एंट्री, वॉलेट मैनेजमेंट और पूरा खाता रिपोर्टिंग चाहते हैं।",
    whatYouCanDo: "आप क्या कर सकते हैं",
    aboutMw: "मार्केट वॉच",
    aboutMwDesc: "सेगमेंट में पर्सनल वॉचलिस्ट के साथ लाइव बोली, मांग और एलटीपी",
    aboutCharts: "चार्ट",
    aboutChartsDesc: "कैंडल, लाइन, बार और एरिया — वॉल्यूम के साथ मल्टी-टाइमफ्रेम OHLC",
    aboutTradeOrders: "ट्रेड और आदेश",
    aboutTradeOrdersDesc: "क्विक ऑर्डर एंट्री, ट्रेड बुक, ऑर्डर बुक और लाइव पोज़ीशन",
    aboutWalletDesc: "फंड जोड़ें, विड्रॉ, बैंक पेआउट और खाता स्टेटमेंट",
    aboutReportsDesc: "लेजर, ट्रेड रिपोर्ट, ट्रायल बैलेंस और ऑडिट लॉग",
    aboutAccounts: "खाते",
    aboutAccountsDesc: "ट्रेडिंग खाते स्विच करें; व्यू-पासवर्ड रीड-ओनली मोड",
    marketsAndSegments: "मार्केट और सेगमेंट",
    nseFutures: "NSE फ्यूचर्स",
    nseOptions: "NSE ऑप्शंस",
    mcxCommodities: "MCX कमोडिटी",
    indexNifty: "इंडेक्स (NIFTY / BANKNIFTY / SENSEX)",
    giftNifty: "GIFT NIFTY",
    aboutPlatform: "प्लेटफ़ॉर्म",
    aboutNote1: "FxBazzar वेब टर्मिनल के साथ सिंक — वही लॉगिन, पोज़ीशन और वॉलेट।",
    aboutNote2: "रियलटाईम भाव Socket.IO से; आदेश, रिपोर्ट और लेजर सुरक्षित REST API से।",
    aboutNote3: "चार्ट प्राथमिकताएँ, कलर टेम्पलेट और डार्क/लाइट थीम आपके डिवाइस पर सेव।",
    technology: "टेक्नोलॉजी",
    aboutDisclaimer:
      "फ्यूचर्स, ऑप्शंस और कमोडिटी में ट्रेडिंग में नुकसान का बड़ा जोखिम है। केवल उसी पूंजी से ट्रेड करें जिसे आप खो सकते हैं, और अपने ब्रोकर की रिस्क लिमिट के अंदर रहें।",
    website: "वेबसाइट",
    aboutLiveData: "लाइव मार्केट डेटा Socket.IO से · खाता डेटा FastTrade API से",
    allRightsReserved: "सर्वाधिकार सुरक्षित।",
    scriptNotFound: "स्क्रिप्ट नहीं मिली",
    sessionExpired: "सत्र समाप्त हो गया है। कृपया फिर से लॉग इन करें।",
    positionNotFoundOrClosed: "पोज़ीशन नहीं मिली या पहले से बंद है।",
  },
  ar: {
    quotes: "الأسعار",
    chart: "الرسم البياني",
    trade: "التداول",
    searchSymbol: "بحث عن رمز",
    addSymbol: "إضافة رمز",
    symbol: "الرمز",
    newOrder: "أمر جديد",
    specification: "المواصفات",
    hide: "إخفاء",
    chartSettings: "إعدادات الرسم",
    positions: "الصفقات",
    deals: "الصفقات المنفذة",
    orders: "الأوامر",
    closePosition: "إغلاق الصفقة",
    modifyPosition: "تعديل الصفقة",
    noOpenPositions: "لا توجد صفقات مفتوحة.",
    buy: "شراء",
    sell: "بيع",
    sellByMarket: "بيع بسعر السوق",
    buyByMarket: "شراء بسعر السوق",
    marketExecution: "تنفيذ سوقي",
    backToChart: "← الرسم البياني",
    close: "إغلاق",
    cancel: "إلغاء",
    menu: "القائمة",
  },
  fr: {
    quotes: "Cours",
    chart: "Graphique",
    trade: "Trade",
    searchSymbol: "Rechercher un symbole",
    addSymbol: "Ajouter un symbole",
    newOrder: "Nouvel ordre",
    specification: "Spécification",
    hide: "Masquer",
    chartSettings: "Paramètres du graphique",
    positions: "Positions",
    deals: "Deals",
    orders: "Ordres",
    closePosition: "Clôturer la position",
    modifyPosition: "Modifier la position",
    noOpenPositions: "Aucune position ouverte.",
    buy: "Achat",
    sell: "Vente",
    sellByMarket: "Vendre au marché",
    buyByMarket: "Acheter au marché",
    marketExecution: "Exécution au marché",
    backToChart: "← Graphique",
    close: "Fermer",
    cancel: "Annuler",
    menu: "Menu",
  },
  de: {
    quotes: "Kurse",
    chart: "Chart",
    trade: "Trade",
    searchSymbol: "Symbol suchen",
    addSymbol: "Symbol hinzufügen",
    newOrder: "Neue Order",
    specification: "Spezifikation",
    hide: "Ausblenden",
    chartSettings: "Chart-Einstellungen",
    positions: "Positionen",
    deals: "Deals",
    orders: "Orders",
    closePosition: "Position schließen",
    modifyPosition: "Position ändern",
    noOpenPositions: "Keine offenen Positionen.",
    buy: "Kaufen",
    sell: "Verkaufen",
    sellByMarket: "Marktverkauf",
    buyByMarket: "Marktkauf",
    marketExecution: "Marktausführung",
    backToChart: "← Chart",
    close: "Schließen",
    cancel: "Abbrechen",
    menu: "Menü",
  },
  es: {
    quotes: "Cotizaciones",
    chart: "Gráfico",
    trade: "Operar",
    searchSymbol: "Buscar símbolo",
    addSymbol: "Añadir símbolo",
    newOrder: "Nueva orden",
    specification: "Especificación",
    hide: "Ocultar",
    chartSettings: "Ajustes del gráfico",
    positions: "Posiciones",
    deals: "Operaciones",
    orders: "Órdenes",
    closePosition: "Cerrar posición",
    modifyPosition: "Modificar posición",
    noOpenPositions: "No hay posiciones abiertas.",
    buy: "Comprar",
    sell: "Vender",
    sellByMarket: "Vender a mercado",
    buyByMarket: "Comprar a mercado",
    marketExecution: "Ejecución a mercado",
    backToChart: "← Gráfico",
    close: "Cerrar",
    cancel: "Cancelar",
    menu: "Menú",
  },
  pt: {
    quotes: "Cotações",
    chart: "Gráfico",
    trade: "Negociar",
    searchSymbol: "Pesquisar símbolo",
    addSymbol: "Adicionar símbolo",
    newOrder: "Nova ordem",
    specification: "Especificação",
    hide: "Ocultar",
    chartSettings: "Definições do gráfico",
    positions: "Posições",
    deals: "Negócios",
    orders: "Ordens",
    closePosition: "Fechar posição",
    modifyPosition: "Modificar posição",
    noOpenPositions: "Sem posições abertas.",
    buy: "Comprar",
    sell: "Vender",
    sellByMarket: "Vender a mercado",
    buyByMarket: "Comprar a mercado",
    marketExecution: "Execução a mercado",
    backToChart: "← Gráfico",
    close: "Fechar",
    cancel: "Cancelar",
    menu: "Menu",
  },
  ru: {
    quotes: "Котировки",
    chart: "График",
    trade: "Торговля",
    searchSymbol: "Поиск символа",
    addSymbol: "Добавить символ",
    newOrder: "Новый ордер",
    specification: "Спецификация",
    hide: "Скрыть",
    chartSettings: "Настройки графика",
    positions: "Позиции",
    deals: "Сделки",
    orders: "Ордера",
    closePosition: "Закрыть позицию",
    modifyPosition: "Изменить позицию",
    noOpenPositions: "Нет открытых позиций.",
    buy: "Купить",
    sell: "Продать",
    sellByMarket: "Продать по рынку",
    buyByMarket: "Купить по рынку",
    marketExecution: "Рыночное исполнение",
    backToChart: "← График",
    close: "Закрыть",
    cancel: "Отмена",
    menu: "Меню",
  },
  "zh-Hans": {
    quotes: "行情",
    chart: "图表",
    trade: "交易",
    searchSymbol: "搜索品种",
    addSymbol: "添加品种",
    newOrder: "新订单",
    specification: "规格",
    hide: "隐藏",
    chartSettings: "图表设置",
    positions: "持仓",
    deals: "成交",
    orders: "挂单",
    closePosition: "平仓",
    modifyPosition: "修改持仓",
    noOpenPositions: "暂无持仓。",
    buy: "买入",
    sell: "卖出",
    sellByMarket: "市价卖出",
    buyByMarket: "市价买入",
    marketExecution: "市价执行",
    backToChart: "← 图表",
    close: "关闭",
    cancel: "取消",
    menu: "菜单",
  },
  "zh-Hant": {
    quotes: "行情",
    chart: "圖表",
    trade: "交易",
    searchSymbol: "搜尋品種",
    addSymbol: "新增品種",
    newOrder: "新訂單",
    specification: "規格",
    hide: "隱藏",
    chartSettings: "圖表設定",
    positions: "持倉",
    deals: "成交",
    orders: "掛單",
    closePosition: "平倉",
    modifyPosition: "修改持倉",
    noOpenPositions: "暫無持倉。",
    buy: "買入",
    sell: "賣出",
    sellByMarket: "市價賣出",
    buyByMarket: "市價買入",
    marketExecution: "市價執行",
    backToChart: "← 圖表",
    close: "關閉",
    cancel: "取消",
    menu: "選單",
  },
  ja: {
    quotes: "気配値",
    chart: "チャート",
    trade: "トレード",
    searchSymbol: "銘柄を検索",
    addSymbol: "銘柄を追加",
    newOrder: "新規注文",
    specification: "仕様",
    hide: "非表示",
    chartSettings: "チャート設定",
    positions: "ポジション",
    deals: "約定",
    orders: "注文",
    closePosition: "決済",
    modifyPosition: "ポジション変更",
    noOpenPositions: "建玉はありません。",
    buy: "買い",
    sell: "売り",
    sellByMarket: "成行売り",
    buyByMarket: "成行買い",
    marketExecution: "成行執行",
    backToChart: "← チャート",
    close: "閉じる",
    cancel: "キャンセル",
    menu: "メニュー",
  },
  ko: {
    quotes: "시세",
    chart: "차트",
    trade: "거래",
    searchSymbol: "종목 검색",
    addSymbol: "종목 추가",
    newOrder: "신규 주문",
    specification: "명세",
    hide: "숨기기",
    chartSettings: "차트 설정",
    positions: "포지션",
    deals: "체결",
    orders: "주문",
    closePosition: "포지션 청산",
    modifyPosition: "포지션 수정",
    noOpenPositions: "열린 포지션이 없습니다.",
    buy: "매수",
    sell: "매도",
    sellByMarket: "시장가 매도",
    buyByMarket: "시장가 매수",
    marketExecution: "시장가 체결",
    backToChart: "← 차트",
    close: "닫기",
    cancel: "취소",
    menu: "메뉴",
  },
  tr: {
    quotes: "Fiyatlar",
    chart: "Grafik",
    trade: "İşlem",
    searchSymbol: "Sembol ara",
    addSymbol: "Sembol ekle",
    newOrder: "Yeni emir",
    specification: "Özellikler",
    hide: "Gizle",
    chartSettings: "Grafik ayarları",
    positions: "Pozisyonlar",
    deals: "İşlemler",
    orders: "Emirler",
    closePosition: "Pozisyonu kapat",
    modifyPosition: "Pozisyonu değiştir",
    noOpenPositions: "Açık pozisyon yok.",
    buy: "Al",
    sell: "Sat",
    sellByMarket: "Piyasadan sat",
    buyByMarket: "Piyasadan al",
    marketExecution: "Piyasa emri",
    backToChart: "← Grafik",
    close: "Kapat",
    cancel: "İptal",
    menu: "Menü",
  },
  it: {
    quotes: "Quotazioni",
    chart: "Grafico",
    trade: "Trade",
    searchSymbol: "Cerca simbolo",
    addSymbol: "Aggiungi simbolo",
    newOrder: "Nuovo ordine",
    specification: "Specifiche",
    hide: "Nascondi",
    chartSettings: "Impostazioni grafico",
    positions: "Posizioni",
    deals: "Deals",
    orders: "Ordini",
    closePosition: "Chiudi posizione",
    modifyPosition: "Modifica posizione",
    noOpenPositions: "Nessuna posizione aperta.",
    buy: "Compra",
    sell: "Vendi",
    sellByMarket: "Vendi a mercato",
    buyByMarket: "Compra a mercato",
    marketExecution: "Esecuzione a mercato",
    backToChart: "← Grafico",
    close: "Chiudi",
    cancel: "Annulla",
    menu: "Menu",
  },
  id: {
    quotes: "Kuotasi",
    chart: "Chart",
    trade: "Trade",
    searchSymbol: "Cari simbol",
    addSymbol: "Tambah simbol",
    newOrder: "Order baru",
    specification: "Spesifikasi",
    hide: "Sembunyikan",
    chartSettings: "Pengaturan chart",
    positions: "Posisi",
    deals: "Deals",
    orders: "Order",
    closePosition: "Tutup posisi",
    modifyPosition: "Ubah posisi",
    noOpenPositions: "Tidak ada posisi terbuka.",
    buy: "Beli",
    sell: "Jual",
    sellByMarket: "Jual pasar",
    buyByMarket: "Beli pasar",
    marketExecution: "Eksekusi pasar",
    backToChart: "← Chart",
    close: "Tutup",
    cancel: "Batal",
    menu: "Menu",
  },
  th: {
    quotes: "ราคา",
    chart: "ชาร์ต",
    trade: "เทรด",
    searchSymbol: "ค้นหาสัญลักษณ์",
    addSymbol: "เพิ่มสัญลักษณ์",
    newOrder: "คำสั่งใหม่",
    specification: "รายละเอียด",
    hide: "ซ่อน",
    chartSettings: "ตั้งค่าชาร์ต",
    positions: "สถานะ",
    deals: "ดีล",
    orders: "ออเดอร์",
    closePosition: "ปิดสถานะ",
    modifyPosition: "แก้ไขสถานะ",
    noOpenPositions: "ไม่มีสถานะเปิด",
    buy: "ซื้อ",
    sell: "ขาย",
    sellByMarket: "ขายราคาตลาด",
    buyByMarket: "ซื้อราคาตลาด",
    marketExecution: "ส่งคำสั่งตลาด",
    backToChart: "← ชาร์ต",
    close: "ปิด",
    cancel: "ยกเลิก",
    menu: "เมนู",
  },
  vi: {
    quotes: "Báo giá",
    chart: "Biểu đồ",
    trade: "Giao dịch",
    searchSymbol: "Tìm mã",
    addSymbol: "Thêm mã",
    newOrder: "Lệnh mới",
    specification: "Thông số",
    hide: "Ẩn",
    chartSettings: "Cài đặt biểu đồ",
    positions: "Vị thế",
    deals: "Giao dịch",
    orders: "Lệnh",
    closePosition: "Đóng vị thế",
    modifyPosition: "Sửa vị thế",
    noOpenPositions: "Không có vị thế mở.",
    buy: "Mua",
    sell: "Bán",
    sellByMarket: "Bán thị trường",
    buyByMarket: "Mua thị trường",
    marketExecution: "Khớp lệnh thị trường",
    backToChart: "← Biểu đồ",
    close: "Đóng",
    cancel: "Hủy",
    menu: "Menu",
  },
  uk: {
    quotes: "Котирування",
    chart: "Графік",
    trade: "Торгівля",
    searchSymbol: "Пошук символу",
    addSymbol: "Додати символ",
    newOrder: "Нове ордер",
    specification: "Специфікація",
    hide: "Приховати",
    chartSettings: "Налаштування графіка",
    positions: "Позиції",
    deals: "Угоди",
    orders: "Ордери",
    closePosition: "Закрити позицію",
    modifyPosition: "Змінити позицію",
    noOpenPositions: "Немає відкритих позицій.",
    buy: "Купити",
    sell: "Продати",
    sellByMarket: "Продати за ринком",
    buyByMarket: "Купити за ринком",
    marketExecution: "Ринкове виконання",
    backToChart: "← Графік",
    close: "Закрити",
    cancel: "Скасувати",
    menu: "Меню",
  },
  pl: {
    quotes: "Notowania",
    chart: "Wykres",
    trade: "Trade",
    searchSymbol: "Szukaj symbolu",
    addSymbol: "Dodaj symbol",
    newOrder: "Nowe zlecenie",
    specification: "Specyfikacja",
    hide: "Ukryj",
    chartSettings: "Ustawienia wykresu",
    positions: "Pozycje",
    deals: "Transakcje",
    orders: "Zlecenia",
    closePosition: "Zamknij pozycję",
    modifyPosition: "Modyfikuj pozycję",
    noOpenPositions: "Brak otwartych pozycji.",
    buy: "Kup",
    sell: "Sprzedaj",
    sellByMarket: "Sprzedaj po rynku",
    buyByMarket: "Kup po rynku",
    marketExecution: "Wykonanie rynkowe",
    backToChart: "← Wykres",
    close: "Zamknij",
    cancel: "Anuluj",
    menu: "Menu",
  },
};

const ACCOUNT = {
  ar: {
    profit: "الربح", credit: "الائتمان", balance: "الرصيد", margin: "الهامش",
    equity: "حقوق الملكية", holding: "الاحتفاظ", level: "المستوى", freeMargin: "الهامش الحر",
    deposit: "إيداع", withdrawal: "سحب", commission: "العمولة", grossProfit: "إجمالي الربح",
    loading: "جارٍ التحميل…", total: "الإجمالي", filled: "منفّذ", canceled: "ملغى", rejected: "مرفوض",
  },
  fr: {
    profit: "Profit", credit: "Crédit", balance: "Solde", margin: "Marge",
    equity: "Équité", holding: "Holding", level: "Niveau", freeMargin: "Marge libre",
    deposit: "Dépôt", withdrawal: "Retrait", commission: "Commission", grossProfit: "Profit brut",
    loading: "Chargement…", total: "Total", filled: "Exécuté", canceled: "Annulé", rejected: "Rejeté",
  },
  de: {
    profit: "Gewinn", credit: "Kredit", balance: "Saldo", margin: "Margin",
    equity: "Eigenkapital", holding: "Holding", level: "Level", freeMargin: "Freie Margin",
    deposit: "Einzahlung", withdrawal: "Auszahlung", commission: "Kommission", grossProfit: "Bruttogewinn",
    loading: "Laden…", total: "Gesamt", filled: "Ausgeführt", canceled: "Storniert", rejected: "Abgelehnt",
  },
  es: {
    profit: "Beneficio", credit: "Crédito", balance: "Balance", margin: "Margen",
    equity: "Patrimonio", holding: "Holding", level: "Nivel", freeMargin: "Margen libre",
    deposit: "Depósito", withdrawal: "Retiro", commission: "Comisión", grossProfit: "Beneficio bruto",
    loading: "Cargando…", total: "Total", filled: "Ejecutado", canceled: "Cancelado", rejected: "Rechazado",
  },
  pt: {
    profit: "Lucro", credit: "Crédito", balance: "Saldo", margin: "Margem",
    equity: "Património", holding: "Holding", level: "Nível", freeMargin: "Margem livre",
    deposit: "Depósito", withdrawal: "Levantamento", commission: "Comissão", grossProfit: "Lucro bruto",
    loading: "A carregar…", total: "Total", filled: "Executado", canceled: "Cancelado", rejected: "Rejeitado",
  },
  ru: {
    profit: "Прибыль", credit: "Кредит", balance: "Баланс", margin: "Маржа",
    equity: "Средства", holding: "Холдинг", level: "Уровень", freeMargin: "Свободная маржа",
    deposit: "Депозит", withdrawal: "Снятие", commission: "Комиссия", grossProfit: "Валовая прибыль",
    loading: "Загрузка…", total: "Всего", filled: "Исполнено", canceled: "Отменено", rejected: "Отклонено",
  },
  "zh-Hans": {
    profit: "利润", credit: "信贷", balance: "余额", margin: "保证金",
    equity: "净值", holding: "持仓保证金", level: "水平", freeMargin: "可用保证金",
    deposit: "入金", withdrawal: "出金", commission: "佣金", grossProfit: "毛利润",
    loading: "加载中…", total: "合计", filled: "已成交", canceled: "已取消", rejected: "已拒绝",
  },
  "zh-Hant": {
    profit: "利潤", credit: "信貸", balance: "餘額", margin: "保證金",
    equity: "淨值", holding: "持倉保證金", level: "水平", freeMargin: "可用保證金",
    deposit: "入金", withdrawal: "出金", commission: "佣金", grossProfit: "毛利潤",
    loading: "載入中…", total: "合計", filled: "已成交", canceled: "已取消", rejected: "已拒絕",
  },
  ja: {
    profit: "損益", credit: "クレジット", balance: "残高", margin: "証拠金",
    equity: "有効証拠金", holding: "保有", level: "証拠金維持率", freeMargin: "余剰証拠金",
    deposit: "入金", withdrawal: "出金", commission: "手数料", grossProfit: "総利益",
    loading: "読み込み中…", total: "合計", filled: "約定", canceled: "取消", rejected: "拒否",
  },
  ko: {
    profit: "수익", credit: "신용", balance: "잔액", margin: "증거금",
    equity: "자산", holding: "홀딩", level: "유지율", freeMargin: "가용 증거금",
    deposit: "입금", withdrawal: "출금", commission: "수수료", grossProfit: "총이익",
    loading: "불러오는 중…", total: "합계", filled: "체결", canceled: "취소", rejected: "거부",
  },
  tr: {
    profit: "Kâr", credit: "Kredi", balance: "Bakiye", margin: "Teminat",
    equity: "Varlık", holding: "Holding", level: "Seviye", freeMargin: "Serbest teminat",
    deposit: "Yatırma", withdrawal: "Çekim", commission: "Komisyon", grossProfit: "Brüt kâr",
    loading: "Yükleniyor…", total: "Toplam", filled: "Gerçekleşen", canceled: "İptal", rejected: "Reddedilen",
  },
  it: {
    profit: "Profitto", credit: "Credito", balance: "Saldo", margin: "Margine",
    equity: "Equity", holding: "Holding", level: "Livello", freeMargin: "Margine libero",
    deposit: "Deposito", withdrawal: "Prelievo", commission: "Commissione", grossProfit: "Profitto lordo",
    loading: "Caricamento…", total: "Totale", filled: "Eseguito", canceled: "Annullato", rejected: "Rifiutato",
  },
  id: {
    profit: "Profit", credit: "Kredit", balance: "Saldo", margin: "Margin",
    equity: "Ekuitas", holding: "Holding", level: "Level", freeMargin: "Margin bebas",
    deposit: "Deposit", withdrawal: "Penarikan", commission: "Komisi", grossProfit: "Profit kotor",
    loading: "Memuat…", total: "Total", filled: "Terisi", canceled: "Dibatalkan", rejected: "Ditolak",
  },
  th: {
    profit: "กำไร", credit: "เครดิต", balance: "ยอดเงิน", margin: "มาร์จิ้น",
    equity: "อิควิตี้", holding: "โฮลดิง", level: "ระดับ", freeMargin: "มาร์จิ้นว่าง",
    deposit: "ฝาก", withdrawal: "ถอน", commission: "คอมมิชชัน", grossProfit: "กำไรรวม",
    loading: "กำลังโหลด…", total: "ทั้งหมด", filled: "สำเร็จ", canceled: "ยกเลิก", rejected: "ปฏิเสธ",
  },
  vi: {
    profit: "Lợi nhuận", credit: "Tín dụng", balance: "Số dư", margin: "Ký quỹ",
    equity: "Tài sản", holding: "Holding", level: "Mức", freeMargin: "Ký quỹ trống",
    deposit: "Nạp", withdrawal: "Rút", commission: "Hoa hồng", grossProfit: "Lợi nhuận gộp",
    loading: "Đang tải…", total: "Tổng", filled: "Đã khớp", canceled: "Đã hủy", rejected: "Từ chối",
  },
  uk: {
    profit: "Прибуток", credit: "Кредит", balance: "Баланс", margin: "Маржа",
    equity: "Кошти", holding: "Холдинг", level: "Рівень", freeMargin: "Вільна маржа",
    deposit: "Депозит", withdrawal: "Виведення", commission: "Комісія", grossProfit: "Валовий прибуток",
    loading: "Завантаження…", total: "Усього", filled: "Виконано", canceled: "Скасовано", rejected: "Відхилено",
  },
  pl: {
    profit: "Zysk", credit: "Kredyt", balance: "Saldo", margin: "Depozyt",
    equity: "Kapitał", holding: "Holding", level: "Poziom", freeMargin: "Wolny depozyt",
    deposit: "Wpłata", withdrawal: "Wypłata", commission: "Prowizja", grossProfit: "Zysk brutto",
    loading: "Ładowanie…", total: "Razem", filled: "Zrealizowane", canceled: "Anulowane", rejected: "Odrzucone",
  },
};

Object.keys(ACCOUNT).forEach((id) => {
  CHROME[id] = { ...CHROME[id], ...ACCOUNT[id] };
});

export function t(key, langId) {
  const id = langId || loadAppLanguageId();
  return STRINGS[id]?.[key] || CHROME[id]?.[key] || STRINGS.en[key] || CHROME_EN[key] || key;
}

/** MT5 keeps buy/sell in English in every UI language. */
export function tSide(side) {
  return String(side || "");
}

export function languageDisplayName(lang) {
  if (!lang) return "";
  if (!lang.native || lang.native === lang.label) return lang.label;
  return `${lang.label} (${lang.native})`;
}
